<template>
  <app-layout title="AttendanceSetting">
    <DxScrollView width="100%" height="100%" class="px-4">
      <!-- Add padding on both sides -->
      <BsOnBoardForm
        :routeDef="this.routeDef"
        :createDef="this.billingDef"
        :modelData="modelData"
        :slug="slug"
        ref="onboardformRenderer"
      />
    </DxScrollView>

    <div class="flex justify-center mt-4 space-x-4">
      <!-- Center the button -->
      <DxButton
        v-if="!isSaved"
        :width="120"
        text="Save Attendance"
        type="default"
        styling-mode="contained"
        @click="saveRecord($event)"
      />

      <DxButton
        v-if="isSaved && !isRunCommand"
        :width="120"
        text="RunCommand"
        type="danger"
        styling-mode="contained"
        @click="runCommand()"
      />

      <DxButton
        v-if="isRunCommand && !isViewedLog"
        :width="120"
        text="View Log"
        type="default"
        styling-mode="contained"
        @click="startMonitoringLog()"
      />

      <!-- Reset Button -->
      <DxButton
        v-if="isReset"
        :width="120"
        text="Reset"
        type="success"
        styling-mode="outlined"
        @click="resetAll"
      />
    </div>

    <!-- Scrollable Output Section -->
    <div id="output" v-if="isViewedLog" class="output-box">
      <div>Queue Monitor</div>
      <div v-if="queueSize !== null">Queue Size: {{ queueSize }}</div>
      <div class="logs-box">
        <div>Logs:</div>
        <ul>
          <li v-for="(log, index) in logs" :key="index">{{ log }}</li>
        </ul>
      </div>
    </div>
  </app-layout>
</template>

<style scoped>
.output-box {
  border: 1px solid #ccc; /* Adds a border to the output box */
  border-radius: 8px; /* Rounded corners */
  padding: 8px; /* Space inside the box */
  margin-top: 16px; /* Adds spacing above */
  background-color: #f9f9f9; /* Light background */
}

.logs-box {
  border: 1px solid #ddd; /* Border for the logs section */
  border-radius: 4px; /* Rounded corners */
  height: 200px; /* Fixed height for scrollable area */
  overflow-y: auto; /* Enables vertical scrolling */
  margin-top: 12px; /* Adds spacing above logs section */
  padding: 8px; /* Adds padding inside the logs section */
  background-color: #ffffff; /* White background for logs */
}

.logs-box ul {
  margin: 0; /* Remove default margin */
  padding: 0; /* Remove default padding */
  list-style: none; /* Remove default list styling */
}

.logs-box li {
  padding: 4px 0; /* Adds space between log items */
  border-bottom: 1px solid #eee; /* Separates log items */
}

.logs-box li:last-child {
  border-bottom: none; /* Remove bottom border for the last item */
}
</style>


  
  <script>
import AppLayout from "@/Layouts/AppLayout.vue";
import DxDateBox from "devextreme-vue/date-box";
import DxButton, { DxButtonTypes } from "devextreme-vue/button";
import BsOnBoardForm from "@include/forms/BsOnBoardForm";
import { DxScrollView } from "devextreme-vue/scroll-view";
import axios from "axios";
export default {
  props: {
    productId: String,
    organisationId: String,
    subscriptionPlanId: String,
    subscriptionPriceId: String,
    accountId: String,
    slug: String,
    billingDef: {
      type: Array,
      default: [],
    },
    addressDef: {
      type: Array,
      default: [],
    },
    ledgerData: Object,
  },

  components: {
    AppLayout,
    DxDateBox,
    DxButton,
    DxButtonTypes,
    BsOnBoardForm,
    DxScrollView,
  },
  data() {
    return {
      isSynced: false, // Initial state for sync
      isSaved: false, // Tracks if "Save Attendance" has been clicked
      isRunCommand: false, // Tracks if "Run Command" has been clicked
      isViewedLog: false, // Tracks if "View Log" has been clicked
      messages: [],
      logs: [],
      queueSize: null,
      processing: false,
      isReset: false,
    };
  },
  methods: {
    saveRecord() {
      if (this.isSaved) return; // Prevent multiple clicks
      let recordData = this.$refs.onboardformRenderer.formData;
      // let altAttendanceUrl = route("attendances.makealtattendance", this.slug);
      let altAttendanceUrl = "/" + this.slug + "/attendances/makealtattendance";

      //this.$inertia.post('/'+this.moduleRoute, this.$refs.formRenderer.formData)

      // console.log("SYNC CRM CALLING", recordData);
      this.$inertia.post(altAttendanceUrl, recordData);
      this.isSaved = true;
    },

    runCommand() {
      if (this.isRunCommand) return; // Prevent multiple clicks
      let altAttendanceProcessUrl =
        "/" + this.slug + "/attendances/process-queue";

      this.$inertia.post(altAttendanceProcessUrl);
      this.isRunCommand = true; // Show the "View Log" button
    },
    startMonitoringLog() {
      if (this.isViewedLog) return; // Prevent multiple clicks
      const attdeventSource = new EventSource("queue-monitor");
      attdeventSource.onmessage = (event) => {
        const data = event.data;

        if (data.startsWith("Queue size:")) {
          this.queueSize = parseInt(data.replace("Queue size:", "").trim());
        } else if (data.startsWith("Log:")) {
          const log = data.replace("Log:", "").trim();
          this.logs.push(log);
          if (this.logs.length > 50) {
            this.logs.shift(); // Keep only the latest 50 logs
          }
        } else if (data.includes("Processing Finished")) {
          attdeventSource.close();
        }
      };

      attdeventSource.onerror = () => {
        console.error("Error connecting to queue monitor.");
        attdeventSource.close();
      };

      this.isViewedLog = true; // Show the output section
      this.isReset = true; // Show  the reset Button
    },
    resetAll() {
      // Reset all states to initial values
      this.isSaved = false;
      this.isRunCommand = false;
      this.isViewedLog = false;
      this.logs = [];
      this.queueSize = null;
      this.isReset = false; // Show  the reset Button
    },
  },
  mounted() {
    //this.startMonitoringLog();
  },
};
</script>
  